import React from "react";
import { createBrowserRouter, Navigate, useLocation } from "react-router-dom";
import { LoginPage } from "./screens/auth/LoginPage";
import { SignupPage } from "./screens/auth/SignupPage";
import { ForgotPasswordPage } from "./screens/auth/ForgotPasswordPage";
import { ResetPasswordConfirmPage } from "./screens/auth/ResetPasswordConfirmPage";
import { VerifyEmailNoticePage } from "./screens/auth/VerifyEmailNoticePage";
import { VerifyEmailPage } from "./screens/auth/VerifyEmailPage";
import { AppLayout } from "./screens/app/AppLayout";
import { SuperAdminConsolePage } from "./screens/app/SuperAdminConsolePage";
import { SuperAdminUsersPage } from "./screens/app/SuperAdminUsersPage";
import { FeedbackAdminPage } from "./screens/app/FeedbackAdminPage";
import { NotFoundPage } from "./screens/misc/NotFoundPage";

function HardRedirect({ to }: { to: string }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

/** Old bookmarks from when the SPA lived under `/app`. */
function LegacyAppPrefixRedirect() {
  const { pathname, search, hash } = useLocation();
  React.useEffect(() => {
    const stripped = pathname.replace(/^\/app(\/|$)/, "/");
    const target = stripped === "/" ? "/login" : stripped;
    window.location.replace(`${target}${search}${hash}`);
  }, [pathname, search, hash]);
  return null;
}

export const router = createBrowserRouter([
  { path: "/app", element: <LegacyAppPrefixRedirect /> },
  { path: "/app/", element: <LegacyAppPrefixRedirect /> },
  { path: "/app/*", element: <LegacyAppPrefixRedirect /> },

  { path: "/admin", element: <HardRedirect to="/admin/" /> },
  { path: "/admin/*", element: <HardRedirect to="/admin/" /> },

  { path: "/", element: <Navigate to="/login" replace /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/accounts/signup", element: <SignupPage /> },
  { path: "/password-reset", element: <ForgotPasswordPage /> },
  { path: "/password-reset/", element: <Navigate to="/password-reset" replace /> },
  { path: "/reset/:uidb64/:token", element: <ResetPasswordConfirmPage /> },
  { path: "/accounts/verify-email-notice", element: <VerifyEmailNoticePage /> },
  { path: "/accounts/verify-email", element: <VerifyEmailPage /> },

  {
    element: <AppLayout />,
    children: [
      { path: "/super_admin/summary", element: <SuperAdminConsolePage /> },
      { path: "/super_admin/user-management", element: <SuperAdminUsersPage /> },
      { path: "/feedback/list", element: <FeedbackAdminPage /> },

      { path: "/tips", element: <HardRedirect to="/" /> },
      { path: "/song_requests", element: <HardRedirect to="/" /> },
      { path: "/event_pages", element: <HardRedirect to="/" /> },
      { path: "/event_pages/create", element: <HardRedirect to="/" /> },
    ],
  },

  { path: "*", element: <NotFoundPage /> },
]);
